import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import style from './SwitchField.css';

const cx = classNames.bind(style);

class SwitchField extends React.Component {
  render() {
    const {
      input,
      onText = 'ON',
      offText = 'OFF',
      disabled,
      onClick,
    } = this.props;

    const labelClassNames = getLabelClassNames(this.props);
    const sliderClassNames = getSliderClassNames(this.props);
    const onClassNames = getOnClassNames(this.props);
    const middleClassNames = getMiddleClassNames(this.props);
    const offClassNames = getOffClassNames(this.props);

    return this._disableWrapper(
      <label onClick={onClick} className={labelClassNames}>
        <input {...input} type="checkbox" disabled={disabled} />
        <div className={sliderClassNames}>
          <div className={onClassNames}>{onText}</div>
          <div className={middleClassNames}>&nbsp;</div>
          <div className={offClassNames}>{offText}</div>
        </div>
      </label>
    );
  }

  _disableWrapper = component => {
    if (this.props.disabled) {
      const popover = (
        <Popover bsClass={`${style.popover} popover`}>
          {this.props.disabledTooltipText}
        </Popover>
      );
      return (
        <OverlayTrigger placement="top" overlay={popover}>
          <div className={style.disabled}>{component}</div>
        </OverlayTrigger>
      );
    }
    return component;
  };
}

function getLabelClassNames(props) {
  const { discount, tableGroupStatus, disabled } = props;
  return cx(
    {
      switch: discount,
      'label-disabled': disabled,
    },
    !discount && {
      'switch-xl': tableGroupStatus,
      'switch-large': !tableGroupStatus,
    }
  );
}

function getSliderClassNames(props) {
  const { discount, tableGroupStatus } = props;
  return cx(
    {
      slider: discount,
      'col-sm-12': true,
    },
    !discount && {
      'slider-xl': tableGroupStatus,
      'slider-large': !tableGroupStatus,
    }
  );
}

function getOnClassNames(props) {
  const { discount, tableGroupStatus } = props;
  return cx(
    {
      on: discount,
    },
    !discount && {
      'on-xl': tableGroupStatus,
      'on-large': !tableGroupStatus,
    }
  );
}

function getMiddleClassNames(props) {
  const { discount, tableGroupStatus } = props;
  return cx(
    {
      middle: discount,
    },
    !discount && {
      'middle-xl': tableGroupStatus,
      'middle-large': !tableGroupStatus,
    }
  );
}

function getOffClassNames(props) {
  const { discount, tableGroupStatus } = props;
  return cx(
    {
      off: discount,
    },
    !discount && {
      'off-xl': tableGroupStatus,
      'off-large': !tableGroupStatus,
    }
  );
}

SwitchField.propTypes = {
  disabled: PropTypes.boolean,
  disabledTooltipText: PropTypes.string,
};

SwitchField.defaultProps = {
  disabled: false,
  disabledTooltipText: 'This field is disabled',
};

export default SwitchField;
